import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import moment from 'moment';
import { withRouter } from "react-router";
import { cloneDeep, sortBy, findIndex, get } from 'lodash';
import { CardPageLayout } from "component-lib/CardPageLayout";
import { mapCompanySelector } from "store/state/auth";
import { DEAL_METRICS, LOAN_STATUSES } from "@loanbossinc/component-library";
import { PdfViewerMode } from "@loanbossinc/pdf-viewer";
import { ToastInfo, ToastError } from "../../components/Global/Toasts/Toasty";
import {
  loanDetailGetLoan,
  loanDetailGetDealMetrics,
  updateLoanDetails,
  loanPostAttachment,
  loanPutAttachment,
  loanDeleteAttachment,
  loanGetAttachments,
  loanGetReferenceFields,
  loanAddReference,
  loanDeleteReference,
  loanUpdateReferences,
  saveRecourseScheduleChange,
} from "./loanDetail.store";
import { LOAN_SECTION_KEYS } from "./loan.constants";
import { AccordionEditSection } from "component-lib/AccordionSection";
import { GenericHeroCard } from "component-lib/";
import { floatingIndexList } from "constants/floatingIndexes";
import { MARKET_VALUE_METHODOLOGY } from "constants/configItemParents";
import { getConfigItemsByParents } from "store/state/configItems";
import DrawerAttachments from "../../modals/DrawerAttachments/DrawerAttachments";
import { rows as additionalAdvancesRows } from "./loan-advances-and-reserves/section-loan-additional-advances-edit-rows";
import { rows as escrowReserveRows } from "./loan-advances-and-reserves/section-loan-escrow-reserve-edit-rows";
import { rows as closingCostsRows } from "./loan-closing-cost/section-loan-closing-costs-edit-rows";
import { rows as cashManagementRows } from "./loan-covenants-and-other/section-cash-management-edit-rows";
import { rows as financialCashManagementRows } from "./loan-financial-reporting/section-loan-cash-management-edit-rows";
import FiancialReportingEditRows from './financial-reporting/FinancialReportingEditRow';
import { rows as financialReportingGeneral } from './financial-reporting/section-loan-cash-management-edit-rows';
import { rows as definitionsRows } from "./loan-covenants-and-other/section-definitions-edit-rows";
import { rows as financialCovenantsRows } from "./loan-covenants-and-other/section-financial-covenants-edit-rows";
import { rows as leasingRows } from "./loan-covenants-and-other/section-leasing-edit-rows";
import { rows as amortizationRows } from "./loan-economics/section-amortization-edit-rows";
import { rows as generalInformationRows } from "./loan-economics/section-general-information-edit-rows";
import { rows as extensionsRows } from "./loan-extensions/section-loan-extension-edit-rows";
import { rows as borrowerDocsRows } from "./loan-financial-reporting/section-loan-borrower-docs-edit-rows";
import { rows as guarantorDocsRows } from "./loan-financial-reporting/section-loan-guarantor-docs-edit-rows";
import { rows as financialMiscellaneousRows } from "./loan-financial-reporting/section-loan-misc-edit-rows";

import { rows as guarantorcompanyRows } from "./loan-guarantor/section-loan-company-guarantor-edit-rows";
import { rows as guarantorPersonalRows } from "./loan-guarantor/section-loan-personal-guarantor-edit-rows";

import { rows as guarantyRows } from "./loan-guaranty/section-loan-guaranty-edit-rows";
import { rows as hedgeRequirementsRows } from "./loan-hedge-requirements/section-loan-hedge-requirements-edit-rows";
import { rows as insuranceRows } from "./loan-insurance/section-loan-insurance-edit-rows";
import { rows as miscRows } from "./loan-misc/section-loan-misc-edit-rows";
import { rows as partialReleaseRows } from "./loan-partial-release/section-loan-partial-release-edit-rows";
import { rows as propertyAllocationsRows } from "./loan-property-allocations/section-loan-property-allocations-edit-rows";
import { rows as prepaymentDetailsRows } from "./loan-prepayment/section-details-edit-rows";
import { rows as prepaymentScheduleRows } from "./loan-prepayment-schedule/loan-prepayment-schedule-edit-rows";
import { rows as forbearanceRows } from "./loan-forbearance/section-loan-forbearance-edit-rows";
import { rows as assumptionsRows } from "./loan-assumptions/section-loan-assumptions-edit-rows";
import { modifyValuesForSerialization, modifyGuarantorRecourseSchedule } from "./loanDetailEditUtil";
import ReferenceDrawer from "modals/ReferenceDrawer/ReferenceDrawer";
import RecourseScheduleDrawer from './loan-guarantor/RecourseScheduleDrawer';
import { SimpleInfoModal } from 'modals/SimpleInfoModal';
import SimpleConfirmDialog from "../../components/Global/ConfirmationDialogs/SimpleConfirmDialog";

import { withLDConsumer } from "launchdarkly-react-client-sdk";

const SIMPLE_INFO_MODAL = 'SIMPLE_INFO_MODAL';
const RECOURSE_SCHEDULE = 'RECOURSE_SCHEDULE';

const dealMetrics = [
  DEAL_METRICS.CLOSING_DATE
  , DEAL_METRICS.PURCHASE_PRICE
  , DEAL_METRICS.SQUARE_FEET
];

class LoanSectionEdit extends Component {
  state = {
    isSaving: false,
    isCanceling: false,
    attachmentDrawerOpen: false,
    referenceDrawerOpen: false,
    openModal: { name: null, data: null },
    confirmationModal: {
      title: "",
      content: "",
      onClose: null,
      onAccept: null,
    },
    recourseSchedualDrawer: {
      item: {},
      initialItem: {},
      onClose: null,
      index: null,
      type: ''
    },
    guarantorRecourseSchedulesIndex: null
  };

  isLockForSaving = false;

  componentDidMount() {
    this.props.loanGetReferenceFields();
    document.getElementById('ScrollToNav').scrollIntoView({ behavior: 'smooth' });
    const { loanId } = this.props.match.params;

    // NOTE: Handles the scenario that the store is not loaded when you come to this page.
    //       ex: refresh page.
    const { loan } = this.props;
    if (!loan) {
      this.props.loanDetailGetLoan({ loanId });
      this.props.loanDetailGetDealMetrics({ loanId, dealMetrics });
      this.props.loanGetAttachments({ modelName: "loan", modelId: loanId });
    }

    // add config item parent Ids here for all of the config item lists in the loan
    this.props.getConfigItemsByParents({
      parentIds: [MARKET_VALUE_METHODOLOGY],
      subKey: 'loanEdit'
    });

    this.setState({ guarantorRecourseSchedulesIndex: null });
  }

  validateLoan = (loan) => {
    return this.validatePropertyAllocation(loan) &&
      this.validateLoanDeliverables(loan);
  }

  getMonthAndYearFromDate = (date) => {
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return { month, year };
  }

  validateLoanDeliverables = (loan) => {
    let isValid = true;
    if (loan.deliverables && loan.deliverables.length > 0) {
      loan.deliverables.forEach(deliverable => {
        // The API saves sameAsMaturity deliverables with the loan maturity date as the end date,
        // so validate against it rather than the stored end date, which may be stale after a maturity extension
        const reportingEndDate = deliverable.sameAsMaturity && loan.details?.maturityDate
          ? loan.details.maturityDate
          : deliverable.reportingEndDate;
        if (deliverable.reportingStartDate && reportingEndDate) {
          const start = this.getMonthAndYearFromDate(moment(deliverable.reportingStartDate).toDate());
          const end = this.getMonthAndYearFromDate(moment(reportingEndDate).toDate());
          if (start.year > end.year || (start.year === end.year && start.month >= end.month)) {
            isValid = false;
          }
        }
      });
    }
    if (!isValid) {
      ToastError("Reporting period must not null and more than 1 month apart.");
      return false;
    }

    return isValid;
  };
  validatePropertyAllocation = (loan) => {
    let totalAllocationPercentage = 0;

    if (loan.properties && loan.properties.length > 0) {
      totalAllocationPercentage += loan.properties.reduce((accum, property) => {
        if (!property) return accum;
        accum += (property.allocationPercent * 1) / 100;
        return accum;
      }, 0);
    }
    if (totalAllocationPercentage > 1) {
      ToastError("Allocation is greater than 100% across all properties");
      return false;
    }

    return true;
  };

  onSubmit = (loan, callback) => {
    // Prevent multiple clicks
    if(this.isLockForSaving) {
      return;
    }

    this.isLockForSaving = true;
    if (loan && this.validateLoan(loan)) {
      const id = loan.details.id;
      const loanDetailsRequest = {};
      const skipCashflowUpdate = this.shouldskipCashflowUpdate();
      if (!id) {
        loanDetailsRequest.isNew = true;
      } else {
        loanDetailsRequest.id = id;
        loanDetailsRequest.isNew = false;
        const clonedValues = cloneDeep(loan);
        loanDetailsRequest.loanDetails = modifyValuesForSerialization(clonedValues);
        loanDetailsRequest.loanDetails.skipCashflowUpdate = skipCashflowUpdate;

        // Hack a-doodle-doo to fix the issue of the return object causing the multi-select to error
        if (this.props.match.url.indexOf('/new/') > -1) {
          callback = () => {
            this.props.history.replace(`/loans/${loan.details.id}`);
          };
        }

        const callbackWrapper = () => {
          const relevantCallback = callback || (() => this.props.loanDetailGetLoan({ loanId: id }));
          relevantCallback();

          // open lock after callback
          this.isLockForSaving = false;
        };

        loanDetailsRequest.callback = callbackWrapper;
        ToastInfo("Saving... Please wait")
        this.props.updateLoanDetails(loanDetailsRequest);
      }
    } else {
      // Validation failed, release the lock so the user can fix the data and save again
      this.isLockForSaving = false;
    }
  }

  shouldskipCashflowUpdate = () => {
    const { sectionName } = this.props.match.params;

    switch (sectionName) {
      // Recalculate metrics
      case LOAN_SECTION_KEYS.FINANCIAL_COVENANTS:
      case LOAN_SECTION_KEYS.AMORTIZATION:
      case LOAN_SECTION_KEYS.LOAN_PREPAYMENT_SCHEDULE:
      case LOAN_SECTION_KEYS.EXTENSIONS:
      case LOAN_SECTION_KEYS.COMPANY_GUARANTORS:
      case LOAN_SECTION_KEYS.PERSONAL_GUARANTORS:
      case LOAN_SECTION_KEYS.MISCELLANEOUS:
      case LOAN_SECTION_KEYS.CLOSING_COSTS:
      case LOAN_SECTION_KEYS.LOAN_PREPAYMENT_DETAILS:
      case LOAN_SECTION_KEYS.PROPERTY_ALLOCATIONS:
      case LOAN_SECTION_KEYS.GENERAL_INFORMATION:
      case LOAN_SECTION_KEYS.LOAN_FORBEARANCE:
        return false;

      // Do not recalculate metrics
      case LOAN_SECTION_KEYS.DEFINITIONS:
      case LOAN_SECTION_KEYS.LOAN_ASSUMPTIONS:
      case LOAN_SECTION_KEYS.BORROWERDOCS:
      case LOAN_SECTION_KEYS.BORROWERREPORTING:
      case LOAN_SECTION_KEYS.GUARANTORDOCS:
      case LOAN_SECTION_KEYS.GUARANTORREPORTING:
      case LOAN_SECTION_KEYS.CASH_MANAGEMENT:
      case LOAN_SECTION_KEYS.CASHMANAGEMENTREPORTING:
      case LOAN_SECTION_KEYS.CASHMANAGEMENTGENERAL:
      case LOAN_SECTION_KEYS.SECTION_ESCROW_RESERVE:
      case LOAN_SECTION_KEYS.ADVANCES_AND_RESERVES:
      case LOAN_SECTION_KEYS.INSURANCE:
      case LOAN_SECTION_KEYS.GUARANTY:
      case LOAN_SECTION_KEYS.QUOTE_HISTORY:
      case LOAN_SECTION_KEYS.VIEW_QUOTE_HISTORY:
      case LOAN_SECTION_KEYS.PARTIAL_RELEASE:
      case LOAN_SECTION_KEYS.COVENANTS_AND_OTHER_DETAILS:
      case LOAN_SECTION_KEYS.FINANCIALMISCELLANEOUS:
      case LOAN_SECTION_KEYS.LEASING:
      case LOAN_SECTION_KEYS.FINANCIAL_CASH_MANAGEMENT:
      case LOAN_SECTION_KEYS.FINANCIAL_REPORTING:
      case LOAN_SECTION_KEYS.HEDGE_REQUIREMENTS:
      case LOAN_SECTION_KEYS.SECTION_ADDITIONAL_ADVANCES:
      case LOAN_SECTION_KEYS.FINANCIAL_REPORTING_GENERAL:
      default:
        return true;
    }
  }

  startSave = () => {
    this.setState({ isSaving: true })
  }
  startCancel = () => {
    this.setState({ isCanceling: true })
  }

  finishSave = () => {
    this.setState({ isSaving: false, isCanceling: false })
  }
  getLeadLenderContacts = () => {
    const { loan } = this.props;
    const msg = "A Lead Lender has not been selected in the Miscellaneous Module. You will not be able to select a Delivery Contact.";
    if (!loan || !loan.details) {
      return [];
    } else if (!loan.details.loanProvider || loan.details.loanProvider.length === 0) {
      ToastInfo(msg);
      return [];
    }

    let leadLender = null;
    if (loan.details.loanProvider.length === 1) {
      leadLender = loan.details.loanProvider[0];
    } else if (loan.details.loanProvider.length > 1) {
      const leadProvider = loan.details.loanProvider.filter(x => x.loanCompanyBridge.isLead);
      if (!leadProvider || leadProvider.length === 0) {
        ToastInfo(msg);
        return [];
      }
      leadLender = leadProvider[0];
    }

    const lenders = loan.ancillary.lenders.filter(x => x.id === leadLender.id);
    // The lead lender may not be in the lender options (e.g. inactive or not typed as a lender).
    return lenders[0]?.contacts || [];
  }

  getCompanyContacts = (loan, companyId, companyList) => {
    if (companyId) {
      const selectedCompany = loan.ancillary[companyList].filter(x => x.id === companyId);
      // The company may not be in the options list (e.g. inactive or missing the matching company type).
      return sortBy(selectedCompany[0]?.contacts || [], "lastName");
    }
    return [];
  };

  handleFinancialReportingPacketRemove = index => {
    this.setState({ isDeleteFinancialReportingPacketConfirmationModalOpen: true, financialReportingPacketIndexToRemove: index });
  }

  deleteFinancialReportingPacket = () => {
    const { loan, history } = this.props;
    const { financialReportingPacketIndexToRemove: index } = this.state;

    loan.deliverables = loan.deliverables.filter(x => x.id !== loan.deliverables[index].id);
    this.onSubmit(loan, history.goBack);
  }

  renderBody = () => {
    const { sectionName, id, index } = this.props.match.params;
    const { loan, loanEditConfigItems, authentication } = this.props;
    if (!loan) return null;

    loan.authentication = authentication;
    const formattedFloatingIndexes = floatingIndexList.map(fi => ({
      name: fi.name,
      id: fi.value
    }));

    const configItems = {
      ...loanEditConfigItems,
      lenders: sortBy(loan.ancillary.lenders, "name"),
      lenderTypes: sortBy(loan.ancillary.lenderTypes, "sortField"),
      servicers: sortBy(loan.ancillary.servicers, "name"),
      brokers: sortBy(loan.ancillary.brokers, "name"),
      lenderCounsels: sortBy(loan.ancillary.lenderCounsels, "name"),
      borrowerCounsels: sortBy(loan.ancillary.borrowerCounsels, "name"),
      titleCompany: sortBy(loan.ancillary.titleCompany, "name"),
      dscrTypes: sortBy(loan.ancillary.dscrTypes, "name"),
      fixedIndexes: sortBy(loan.ancillary.fixedIndexes, "name"),
      floatingIndexes: formattedFloatingIndexes,
      amortizationTypes: sortBy(loan.ancillary.amortizationTypes, "name"),
      propertySizes: sortBy(loan.ancillary.propertySizes, "name"),
      guarantyTypes: sortBy(loan.ancillary.guarantyTypes, "name"),
      dealProperties: sortBy(loan.ancillary.dealProperties, "name"),
      loanSenorityTypes: sortBy(loan.ancillary.loanSenorityTypes, "name"),
      loanStatuses: sortBy(loan.ancillary.loanStatuses, "name"),
      loanTypes: loan.ancillary.loanTypes,
      roundingList: sortBy(loan.ancillary.roundingList, "name"),
      daycountList: sortBy(loan.ancillary.daycountList, "name"),
      businessDayAdjustmentList: sortBy(loan.ancillary.businessDayAdjustmentList, "name"),
      prepaymentTypes: loan.ancillary.prepaymentTypes,
      contacts: sortBy(loan.ancillary.contacts, "sortField"),
      borrowerDocsRows: sortBy(loan.ancillary.borrowerDocs, "name"),
      frequencies: sortBy(loan.ancillary.frequencies, 'name'),
      guarantorDocsRows: sortBy(loan.ancillary.guarantorDocs, "name"),
      cashManagementDocs: sortBy(loan.ancillary.cashManagementDocs, "name"),
      requiredCalculations: sortBy(loan.ancillary.requiredCalculations, "name"),
      deferralRepaymentConditions: sortBy(loan.ancillary.deferralRepaymentConditions, "sortField"),
      deliveryPeriodProximities: sortBy(loan.ancillary.deliveryPeriodProximities, "sortField"),
      reportingEntities: sortBy(loan.ancillary.reportingEntities, "name"),
      reportingTypes: sortBy(loan.ancillary.reportingTypes, "name"),
      loanRiskRatingTypes: sortBy(loan.ancillary.loanRiskRatingTypes, "sortField"),
      loanProviderContacts: [],
      recourseTypes: sortBy(loan.ancillary.recourseTypes, "sortField")
    };

    const quoteStatuses = [LOAN_STATUSES.QUOTE, LOAN_STATUSES.REJECTED_QUOTE, LOAN_STATUSES.PASSED_QUOTE, LOAN_STATUSES.WINNING_QUOTE];
    const isQuote = quoteStatuses.some(status => status === loan.loanStatusId);

    let sectionRows = null;
    let itemIndex = -1;
    let saveOrderChange = () => { };
    switch (sectionName) {
      case LOAN_SECTION_KEYS.SECTION_ADDITIONAL_ADVANCES:
        sectionRows = additionalAdvancesRows;
        break;
      case LOAN_SECTION_KEYS.SECTION_ESCROW_RESERVE:
        sectionRows = escrowReserveRows(loan);
        saveOrderChange = (items, formik) => {
          let type = '';
          let loan = formik.current.state.values;
          for (let index = 0; index < items.length; index++) {
            const loanDeadlines = items[index];
            loanDeadlines.sortOrder = index + 1;
            type = loanDeadlines.type;
          }
          if (type === 'CAPEX_COMPLETION_DEADLINE')
            loan.details.capExCompletionDeadline = items;
          else
            loan.details.repairCompletionDeadline = items;

          formik.current.setValues({ ...formik.current.state.values, loan });
        }
        break;
      case LOAN_SECTION_KEYS.CLOSING_COSTS:
        sectionRows = closingCostsRows;
        break;
      case LOAN_SECTION_KEYS.FINANCIAL_COVENANTS:
        sectionRows = financialCovenantsRows;
        break;
      case LOAN_SECTION_KEYS.CASH_MANAGEMENT:
        sectionRows = cashManagementRows;
        break;
      case LOAN_SECTION_KEYS.FINANCIAL_CASH_MANAGEMENT:
        sectionRows = financialCashManagementRows;
        break;
      case LOAN_SECTION_KEYS.BORROWERREPORTING:
        itemIndex = id && id !== "new" ? findIndex(loan.deliverables, deliverable => deliverable.id === id) : index;
        if (id === "new" && !loan.deliverables.some(x => x.id === "new")) {
          const deliverable = { id: "new", deliverableType: 'borrower', deliveryPeriodProximityId: '9866cd91-727b-11ec-aa9a-98fa9bde2f84', deliverablesConfigItems: [], requiredCalculations: [] };
          loan.deliverables.push(deliverable);
          itemIndex = loan.deliverables.length - 1;
        }
        sectionRows = FiancialReportingEditRows('borrowerDocsRows', parseInt(itemIndex), 'Borrower Reporting', 'borrower', this.handleFinancialReportingPacketRemove);
        break;
      case LOAN_SECTION_KEYS.GUARANTORREPORTING:
        itemIndex = id && id !== "new" ? findIndex(loan.deliverables, deliverable => deliverable.id === id) : index;
        if (id === "new" && !loan.deliverables.some(x => x.id === "new")) {
          const deliverable = { id: "new", deliverableType: 'guarantor', deliveryPeriodProximityId: '9866cd91-727b-11ec-aa9a-98fa9bde2f84', deliverablesConfigItems: [], requiredCalculations: [] };
          loan.deliverables.push(deliverable);
          itemIndex = loan.deliverables.length - 1;
        }
        sectionRows = FiancialReportingEditRows('guarantorDocsRows', parseInt(itemIndex), 'Guarantor Reporting', 'guarantor', this.handleFinancialReportingPacketRemove);
        break;
      case LOAN_SECTION_KEYS.CASHMANAGEMENTREPORTING:
        itemIndex = id && id !== "new" ? findIndex(loan.deliverables, deliverable => deliverable.id === id) : index;
        if (id === "new" && !loan.deliverables.some(x => x.id === "new")) {
          const deliverable = { id: "new", deliverableType: 'cashManagement', deliveryPeriodProximityId: '9866cd91-727b-11ec-aa9a-98fa9bde2f84', deliverablesConfigItems: [], requiredCalculations: [] };
          loan.deliverables.push(deliverable);
          itemIndex = loan.deliverables.length - 1;
        }
        sectionRows = FiancialReportingEditRows('cashManagementDocs', parseInt(itemIndex), 'Cash Management Reporting', 'cashManagement', this.handleFinancialReportingPacketRemove);
        break;
      case LOAN_SECTION_KEYS.FINANCIAL_REPORTING_GENERAL:
        sectionRows = financialReportingGeneral;
        break;
      case LOAN_SECTION_KEYS.LEASING:
        sectionRows = leasingRows;
        break;
      case LOAN_SECTION_KEYS.DEFINITIONS:
        sectionRows = definitionsRows;
        break;
      case LOAN_SECTION_KEYS.GENERAL_INFORMATION:
        sectionRows = generalInformationRows(this.props.flags);
        break;
      case LOAN_SECTION_KEYS.AMORTIZATION:
        sectionRows = amortizationRows;
        break;
      case LOAN_SECTION_KEYS.EXTENSIONS:
        itemIndex = id && id !== "new" ? findIndex(loan.extensions, x => x.id == id) : index;
        if (id === "new" && !loan.extensions.some(x => x.id === "new")) {
          let start = loan.details.maturityDate;
          let end = moment(loan.details.maturityDate).add(1, 'y');
          if (index > 0) {
            const lastExtension = loan.extensions[index - 1];
            start = moment(lastExtension.extensionEnd).add(1, 'd').format('MM-DD-YYYY');
            end = moment(start).add(1, 'y');
          }

          const extension = { id: "new", extensionStart: start, extensionEnd: end };
          loan.extensions.push(extension);
        }
        sectionRows = extensionsRows(itemIndex, isQuote, this.onSubmit, this.props.history.goBack);
        break;
      case LOAN_SECTION_KEYS.BORROWERDOCS:
        sectionRows = borrowerDocsRows;
        break;
      case LOAN_SECTION_KEYS.GUARANTORDOCS:
        sectionRows = guarantorDocsRows;
        break;
      case LOAN_SECTION_KEYS.FINANCIALMISCELLANEOUS:
        configItems.deliveryContacts = this.getLeadLenderContacts()
        sectionRows = financialMiscellaneousRows;
        break;
      case LOAN_SECTION_KEYS.GUARANTY:
        sectionRows = guarantyRows;
        break;
      case LOAN_SECTION_KEYS.COMPANY_GUARANTORS:
        itemIndex = id && id !== "new" ? findIndex(loan.companyGuarantors, x => x.id == id) : index;
        sectionRows = guarantorcompanyRows(loan, itemIndex, isQuote, this.onSubmit, this.props.history.goBack, this.openDrawer, this.deleteRecourseScheduleItem, this.expandRecourseScheduleRow, this.state.guarantorRecourseSchedulesIndex);
        break;
      case LOAN_SECTION_KEYS.PERSONAL_GUARANTORS:
        itemIndex = id && id !== "new" ? findIndex(loan.personalGuarantors, x => x.id == id) : index;
        sectionRows = guarantorPersonalRows(loan, itemIndex, isQuote, this.onSubmit, this.props.history.goBack, this.openDrawer, this.deleteRecourseScheduleItem, this.expandRecourseScheduleRow, this.state.guarantorRecourseSchedulesIndex);
        break;
      case LOAN_SECTION_KEYS.HEDGE_REQUIREMENTS:
        sectionRows = hedgeRequirementsRows;
        break;
      case LOAN_SECTION_KEYS.INSURANCE:
        sectionRows = insuranceRows;
        break;
      case LOAN_SECTION_KEYS.MISCELLANEOUS:
        if (loan.details.loanProvider && loan.details.loanProvider.length > 0) {
          loan.details.loanProvider.forEach((loanProvider, index) => {
            const lenderCounselCompanyId = loanProvider.loanCompanyBridge.companyId;
            configItems.loanProviderContacts[index] = this.getCompanyContacts(loan, lenderCounselCompanyId, 'lenders');
          });
        }

        const lenderCounselCompanyId = get(loan, 'details.lenderCounselCompanyId');
        configItems.lendersCounselContact = this.getCompanyContacts(loan, lenderCounselCompanyId, 'lenderCounsels');

        const borrowerCounselCompanyId = get(loan, 'details.borrowerCounselCompanyId');
        configItems.borrowerCounselContacts = this.getCompanyContacts(loan, borrowerCounselCompanyId, 'borrowerCounsels');

        const titleCompanyId = get(loan, 'details.titleCompanyId');
        configItems.titleCompanyContacts = this.getCompanyContacts(loan, titleCompanyId, 'titleCompany');

        sectionRows = miscRows(this.getCompanyContacts, configItems);
        break;
      case LOAN_SECTION_KEYS.PARTIAL_RELEASE:
        sectionRows = partialReleaseRows;
        break;
      case LOAN_SECTION_KEYS.PROPERTY_ALLOCATIONS:
        sectionRows = propertyAllocationsRows;
        break;
      case LOAN_SECTION_KEYS.LOAN_PREPAYMENT_DETAILS:
        sectionRows = prepaymentDetailsRows;
        break;
      case LOAN_SECTION_KEYS.LOAN_PREPAYMENT_SCHEDULE:
        itemIndex = id && id !== "new" ? findIndex(loan.prepaymentSchedules, x => x.id == id) : index;

        if (id === "new" && !loan.prepaymentSchedules.some(x => x.id === "new")) {
          /*
            First Prepayment Schedule Start Date should be loan Close and End Date should be loan Maturity, 
            Second Prepayment Schedule Start Date should be one day after the previous Schedule's End Date and End Date should be Maturity, etc.
          */
          let startDate = loan.details.closingDate;
          let endDate = loan.details.maturityDate;
          if (index > 0) {
            const lastPrepayment = loan.prepaymentSchedules[index - 1];

            const a = moment(lastPrepayment.end);
            const b = a.startOf('day');
            const isSame = b.isSame(endDate);

            if (lastPrepayment.end && isSame) {
              ToastInfo("Please adjust the end date of the previous prepayment to be before the loan maturity date");
              this.props.history.goBack();
            } else {
              startDate = moment(lastPrepayment.end).add(1, 'd').format('MM-DD-YYYY');
            }
          }
          const prepaymentSchedule = { id: "new", begin: startDate, end: endDate };
          loan.prepaymentSchedules.push(prepaymentSchedule);
        }

        sectionRows = prepaymentScheduleRows(itemIndex, isQuote, this.onSubmit, this.props.history.goBack);
        break;
      case LOAN_SECTION_KEYS.LOAN_FORBEARANCE:
        sectionRows = forbearanceRows;
        saveOrderChange = (items, formik) => {
          let loan = formik.current.state.values;
          for (let index = 0; index < items.length; index++) {
            const loanForbearanceCustom = items[index];
            loanForbearanceCustom.sortOrder = index + 1;
          }
          loan.forbearance.loanForbearanceCustom = items;
          formik.current.setValues({ ...formik.current.state.values, loan });
        }
        break;
      case LOAN_SECTION_KEYS.LOAN_ASSUMPTIONS:
        sectionRows = assumptionsRows
        break;
      default:
        sectionRows = null;
        break;
    }

    if (!sectionRows)
      return null;

    return (<AccordionEditSection
      rows={sectionRows}
      configItems={configItems}
      finishSave={this.finishSave}
      isSaving={this.state.isSaving}
      isCanceling={this.state.isCanceling}
      data={loan}
      onSubmit={this.onSubmit}
      onCancel={this.finishSave}
      saveOrderChange={saveOrderChange}
      eventHandlers={{ onOpenReferenceDrawer: this.handleOpenReferenceDrawer }}
    />);
  }

  handleOpenReferenceDrawer = referencedFieldPath => {
    this.setState({ attachmentDrawerOpen: true, currentReferencedFieldPath: referencedFieldPath });
  };

  handleOpenPdfForReference = file => {
    this.setState({ attachmentDrawerOpen: false, referenceDrawerOpen: true, referenceCurrentFile: file });
  };

  handleReferenceDrawerClose = () => {
    this.setState({ attachmentDrawerOpen: true, referenceDrawerOpen: false });
  };

  handleReferenceDrawerBack = referencedFieldPath => {
    this.setState({ attachmentDrawerOpen: true, currentReferencedFieldPath: referencedFieldPath, referenceDrawerOpen: false });
  };

  openModal = (name, data = null) => this.setState({ openModal: { name, data } });
  closeModal = () => this.setState({ openModal: { name: null, data: null } });
  isModalOpen = (modalName) => {
    const { openModal } = this.state;
    return openModal.name === modalName;
  }

  openConfirmationDialog = (title, onClose, onAccept, content) => {
    this.setState({ confirmationModal: { title, onClose, onAccept, content } });
    this.openModal(SIMPLE_INFO_MODAL);
  }

  deleteRef = (reference, callback) => {
    if (reference.id) {
      this.openConfirmationDialog("Delete Reference", this.closeModal, () => {
        this.props.loanDeleteReference({ reference, callback });
        this.closeModal();
      },
        (<><p>Are you sure that you want to delete this reference?</p> <p>This action cannot be undone.</p></>)
      );
    } else {
      this.openConfirmationDialog("Delete Reference", this.closeModal, () => {
        this.closeModal();
      },
        (<><p>Please refresh your browser and try again.</p></>)
      );
    }
  };

  updateReferences = (references) => {
    const { loanId } = this.props.match.params;
    this.props.loanUpdateReferences({ references, modelName: "loan", modelId: loanId });
  };

  openDrawer = (item, index, type) => {
    const { loan } = this.props;
    if (!loan) return null;

    const guarantors = get(loan, type);
    const guarantor = guarantors[index];
    const initialItem = guarantor.guarantorRecourseSchedules.find(x => x.sortOrder === 0);
    this.setState({ recourseSchedualDrawer: { item, initialItem, closeModal: this.closeModal, index, type } });
    this.openModal(RECOURSE_SCHEDULE);
  }

  deleteRecourseScheduleItemAction = (item, index, type) => {
    const { loan } = this.props;
    if (!loan) return null;

    const guarantors = get(loan, type);
    const guarantor = guarantors[index];
    const toDeleteIndex = guarantor.guarantorRecourseSchedules.findIndex(x => x.id === item.id);
    guarantor.guarantorRecourseSchedules.splice(toDeleteIndex, 1);
    this.onSubmit(loan)
  }

  deleteRecourseScheduleItem = (item, index, type) => {
    this.openConfirmationDialog(
      "Delete Reference",
      this.closeModal,
      () => { this.deleteRecourseScheduleItemAction(item, index, type); this.closeModal(); },
      (<><p>Are you sure that you want to do this?</p> <p>This cannot be undone.</p></>)
    );
  }

  saveRecourseScheduleChange = (recourseSchedule) => {
    const { loanId } = this.props.match.params;
    const schedule = modifyGuarantorRecourseSchedule(recourseSchedule);
    this.props.saveRecourseScheduleChange({ recourseSchedule: schedule, callback: () => this.props.loanDetailGetLoan({ loanId }) });
  };

  recourseAmountChange = (value) => {
    const { loan } = this.props;
    if (!loan) return null;

    const { recourseSchedualDrawer: { item, index, type } } = this.state;
    const guarantors = get(loan, type);
    const guarantor = guarantors[index];
    const guarantorRecourseSchedules = guarantor.guarantorRecourseSchedules;

    for (let i = 0; i < guarantorRecourseSchedules.length; i++) {
      const schedule = modifyGuarantorRecourseSchedule(guarantorRecourseSchedules[i]);
      if (schedule.sortOrder !== 0) {
        schedule.recourseType = value.recourseType;
        schedule.recourseAmount = null;
        schedule.recoursePercent = null;
        const callback = i + 1 === guarantorRecourseSchedules.length ? () => this.props.loanDetailGetLoan({ loanId: loan.details.id }) : null;
        this.props.saveRecourseScheduleChange({ recourseSchedule: schedule, callback });
      }
    }
  };

  expandRecourseScheduleRow = (item, index, type) => {
    const { loan } = this.props;
    if (!loan) return null;

    const allGuarantors = [...loan.companyGuarantors, ...loan.personalGuarantors]
    allGuarantors.forEach(ag => ag.guarantorRecourseSchedules.forEach(x => {
      if (x.id !== item.id)
        x.isDetailsExpanded = false;
    }));

    const guarantors = get(loan, type);
    const guarantor = guarantors[index];
    const guarantorRecourseSchedulesIndex = guarantor.guarantorRecourseSchedules.findIndex(x => x.id === item.id);

    item.isDetailsExpanded = !item.isDetailsExpanded;
    this.setState({ guarantorRecourseSchedulesIndex: guarantorRecourseSchedulesIndex });
  };
  handleCurrent = (currentId) => {
    const { recourseSchedualDrawer: { index, type } } = this.state
    const { loan } = this.props;
    if (!loan) return null;

    const guarantors = get(loan, type);
    const guarantor = guarantors[index];
    const guarantorRecourseSchedules = guarantor.guarantorRecourseSchedules;
    for (let i = 0; i < guarantorRecourseSchedules.length; i++) {
      const schedule = guarantorRecourseSchedules[i];
      if (schedule.id !== currentId)
        schedule.isCurrent = false;
    }
    this.onSubmit(loan);
  };

  render() {
    const { loan } = this.props;
    const { loanId } = this.props.match.params;
    if (!loan) return null;
    const year = moment(loan.details.closingDate, "YYYY-MM-DD").format("YYYY");
    const title = `${loan.details["lenderCompany.name"]} ${year}`;

    return (
      <>
        {this.state.isDeleteFinancialReportingPacketConfirmationModalOpen &&
          <SimpleConfirmDialog
            title="Delete report packet"
            message="Deleting this report packet will delete all reports and tasks associated with this report packet, including those that have already been delivered to your lender.  Are you sure you want to continue?"
            noText="Cancel"
            yesText="Delete"
            modalOpen={true}
            handleNo={() => {
              this.setState({ isDeleteFinancialReportingPacketConfirmationModalOpen: false });
            }}
            handleYes={() => {
              this.deleteFinancialReportingPacket();
            }} />
        }

        <DrawerAttachments
          referenceMode
          isOpen={this.state.attachmentDrawerOpen}
          files={this.props.attachments}
          authentication={this.props.authentication}
          closeDrawer={() => this.setState({ attachmentDrawerOpen: false })}
          onAdd={file => this.props.loanPostAttachment({ file, loanId })}
          onUpdate={file => this.props.loanPutAttachment({ file, loanId })}
          onRemove={file => this.props.loanDeleteAttachment({ fileId: file.id, loanId })}
          onOpenPdfForReference={file => this.handleOpenPdfForReference(file)}
          references={this.props.loan.references}
					referencedFieldPath={this.state.currentReferencedFieldPath}
					referenceFields={this.props.referenceFields}
        />
        <ReferenceDrawer
          flags={this.props.flags}
          mode={PdfViewerMode.Editable}
          open={this.state.referenceDrawerOpen}
          currentFile={this.state.referenceCurrentFile}
          getBufferForFile={this.props.getBufferForFile}
          modelId={loan}
          referencedFieldPath={this.state.currentReferencedFieldPath}
          references={this.props.loan.references}
          referenceFields={this.props.referenceFields}
          onAddReference={this.props.loanAddReference}
          onRemoveReference={this.deleteRef}
          onUpdateReferences={this.updateReferences}
          onClose={this.handleReferenceDrawerClose}
					onBack={this.handleReferenceDrawerBack}
					onBackLabel="Attachments"
          canDelete={!this.props.authentication.isGuest}
        />

        <RecourseScheduleDrawer
          open={this.isModalOpen(RECOURSE_SCHEDULE)}
          onClose={this.closeModal}
          onSave={this.saveRecourseScheduleChange}
          data={this.state.recourseSchedualDrawer.item}
          initialItem={this.state.recourseSchedualDrawer.initialItem}
          handleCurrent={this.handleCurrent}
          recourseAmountChange={this.recourseAmountChange}
        />

        <SimpleInfoModal
          title={this.state.confirmationModal.title}
          isOpen={this.isModalOpen(SIMPLE_INFO_MODAL)}
          onClose={() => this.state.confirmationModal.onClose()}
          onAccept={() => this.state.confirmationModal.onAccept()}
          content={this.state.confirmationModal.content}
        />

        <CardPageLayout {...this.props}
          isReversed
          bannerImageUrl={this.props.loan && this.props.loan.details && this.props.loan.details.deal && this.props.loan.details.deal.imageLarge}
          cardComponent={<GenericHeroCard save={this.startSave} cancel={this.startCancel} {...{ ...this.props, deal: this.props.loan.details.deal, title: title, backLabel: "Loan Details" }} />}
          bodyComponent={
            <div key={"bodyKey"} className="d-flex f-1 flex-column">
              {this.renderBody()}
            </div>
          }
        />
      </>
    );
  }
}

const mapStateToProps = ({ newLoanDetail, authentication, configItems }) => ({
  ...newLoanDetail
  , company: mapCompanySelector(authentication)
  , authentication
  , loanEditConfigItems: configItems.configItemsByParents.loanEdit || {}
});

export default compose(
  withRouter,
  withLDConsumer(),
  connect(mapStateToProps, {
    loanDetailGetLoan,
    loanDetailGetDealMetrics,
    getConfigItemsByParents,
    updateLoanDetails,
    loanGetAttachments,
    loanPostAttachment,
    loanPutAttachment,
    loanDeleteAttachment,
    loanGetReferenceFields,
    loanAddReference,
    loanDeleteReference,
    loanUpdateReferences,
    saveRecourseScheduleChange
  })
)(LoanSectionEdit);
